module.exports = __webpack_public_path__ + "static/media/b2.38c94443.jpg";